/*
 * Join Ctrl
 * used in step1 of enrollment
 */
module.controller('step-1-joinCtrl', ['$scope', '$state', 'EV_STEP1', '$http', '$timeout', '$filter', '$window', 'Transform', 'baseURI', '$location', 'Session', '$rootScope', '$stateParams','brandService', function ($scope, $state, EV_STEP1, $http, $timeout, $filter, $window, Transform, baseURI, $location, Session, $rootScope, $stateParams, brandService){
  var checkEmailUrl = baseURI + 'cardholder/checkemail';
  var checkCardNumberUrl = baseURI + 'sub-card/register';
  var redeemCode = $stateParams.redeem;
  var email = $state.params.email;
  var promoValid = false;
  $scope.displayPromoCode = true;
  $scope.displaySideImage = true;

  $scope.latestAgeYear = new Date().getFullYear() - 18;

  // Check email from params
  if (typeof email !== "undefined") {
    $scope.formData.Email = email;
    checkEmail(email);
  }

  // get referrer from cookie, if not there check for it in doc
  var referrer = Session.getReferrer() || document.referrer;

  $scope.showValidateEmail = false;
  $scope.loadingEmailVerification = false;
  $scope.brand = brandService.getBrand($stateParams.brand);

  if ($scope.brand.name === 'fancards' || $scope.brand.parentBrand === 'fancards') {
    $scope.displayPromoCode = false;
  }

  // $scope.cardStyles is used to display the cards in step1
  // if there's a promoCode present, override $scope.cardStyles.name
  // and $scope.cardStyles.cards with it
  $scope.cardStyles = angular.copy($scope.brand);

  // check for redeem code in url
  if(redeemCode){
    Session.setPromoCode(redeemCode);
    if(redeemCode === 'qlink'){
      $scope.displayPromoCode = false;
      $scope.displaySideImage = false;
    }
  } else {
    Session.setPromoCode('');
  }

  // Check if the session has a promo code
  if(Session.getPromoCode()){
    promoCode = Session.getPromoCode();
    $scope.formData.PromoCode = promoCode;

    // Replace $scope.cardStyles.name and $scope.cardStyles.cards with promoCode
    // to display the corresponding card styles
    if(brandService.getDistributor(promoCode)) {
        $scope.cardStyles.name = 'distributors';
        $scope.cardStyles.cards = brandService.getDistributor(promoCode).cards;
    }
  }

  // check if there is a referrer cookie
  if(referrer){
    $scope.parent.referrer = referrer;

    // lets get the root domain now
    if(referrer != 'direct'){
      var domain = getHost(referrer);
      // split the domain
      var sd = domain.split('.');

      // check if there is a subdomain
      if(sd.length > 3){
        domain = sd.slice(-3).join('.');
      }

      $scope.parent.referrerDomain = domain;
    }
  }

  /*if (navigator.userAgent.indexOf('iPhone OS') > -1 || navigator.userAgent.indexOf('Android') > -1 ) {
    alert('We\'re sorry, enrollment is temporarily unavailable. Please return later to try again.');
    $state.go('root.login', {brand: Session.getBrand()});
  }*/

  // parse host name from ak_ref cookie
  function getHost(url){
    var parser = document.createElement('a');
    parser.href = url;

    return parser.host;
  }

  // validate inputs in step1
  $scope.validate = function(formData){
    var valid = true;
    if($scope.joinType != 'register'){
      for(var input in EV_STEP1){
        if(!formData[input]){
          $scope.alertError.show = true;
          $scope.alertError.message = EV_STEP1[input].message;
          valid = false;
          break;
        }
      }
    } else {
      // Check the card number and check it matches the original tested
      if(valid && ( $scope.$parent.validation.cardNumber != $scope.formData.CardNumber ) ){
        valid = false;
        $scope.alertError.show = true;
        $scope.alertError.message = 'Oops, looks like you have provided an invalid Card Number.';
      }
      if(valid && !$scope.$parent.validation.validCardNumber){
        valid = false;
        $scope.alertError.show = true;
        $scope.alertError.message = 'Oops, looks like you have provided an invalid Card Number.';
      }
    }
    if(valid && !$scope.$parent.validation.validEmail){
      valid = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please Provide a Valid Email Address';
    }
    if(valid && $scope.$parent.validation.temporaryIssue){
      valid = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Temporary Issue, Please Try Again Later';
    }
    if(valid && !$scope.$parent.validation.uniqueEmail){
      valid = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Oops, This Email Address Has Already Been Taken';
    }
    if($scope.requirePromo() && !formData.PromoCode){

        valid = false;
        promoValid = false;
        $scope.alertError.show = true;
        $scope.alertError.message = "In order to enroll, you must enter a valid Invitation Code.";


    }else{
      promoValid = true;
    }
    if(valid && $scope.$parent.validation.verifiedEmail && promoValid){
      successVerfication();
      // If the form is valid lets verify the email
    } else if(valid) {
      verifyEmail();
    }
  };

  $scope.checkEmail = checkEmail;

  var initialEmail = '';

  // POST for email availability
  function checkEmail(email) {
    // Don't POST if email is unchanged
    if (initialEmail !== email) {
      initialEmail = email;
      // if user has changed email set verified to false
      $scope.$parent.validation.verifiedEmail = false;
      $scope.$parent.validation.uniqueEmail = true;
      if(email){
        $scope.$parent.validation.validEmail = true;
        $http({
          method: 'POST',
          url: checkEmailUrl,
          headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
          data: 'Email=' + encodeURIComponent(email)
        }).then(function (resp){
          $scope.$parent.validation.uniqueEmail = resp.data.Success;
        }).catch(function (error){
          if (error.status === 429) {
            $scope.$parent.validation.temporaryIssue = true;
          } else {
            $scope.$parent.validation.uniqueEmail = false;
          }
        }).then(function(){
          $scope.$parent.validation.emailBlurred = true;
        });
      } else {
        $scope.$parent.validation.validEmail = false;
        $scope.$parent.validation.emailBlurred = true;
      }
    }
  }

  // POST for card number
  $scope.checkCardNumber = function (cardNumber){
    if(cardNumber){
      var checkCardRequest = {
        CardNumber: cardNumber,
        _key: $scope.brand.api_key
      };
      $http({
        method: 'POST',
        url: checkCardNumberUrl,
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(checkCardRequest)
      }).then(function (resp){
        var data = resp.data;

        $scope.$parent.validation.cardNumber = cardNumber;
        $scope.$parent.validation.validCardNumber = (data.Success);
      }).catch(function (error){
        $scope.$parent.validation.validCardNumber = false;
      });
    }
  };

  $scope.updatePhone = function() {
    $scope.formData.Phone = $scope.formData.Phone1 + $scope.formData.Phone2 + $scope.formData.Phone3;
  };

  // User successfully completed form; now verify the email
  var verifyEmail = function(){
    selectVerificationMethod();
  };

  // Prompt for verification method
  var selectVerificationMethod = function() {
    $scope.formData.updatedEmail = null;
    $scope.formData.verificationMethod = 'phone';

    $scope.verificationMethodChange = function(method) {
      $scope.formData.verificationMethod = method;
      $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
      $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';
    };

    // Default value
    $scope.verificationMethodChange('phone');

    // Open the modal
    $scope.showSelectVerificationMethod = true;
  };

  $scope.submitSelectVerificationMethod = function() {
    $scope.showSelectVerificationMethod = false;

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;
    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.Phone : $scope.formData.Email,
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'member/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.Phone : $scope.formData.Email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  $scope.close = function(){
    // Close the modal
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };
  $scope.requirePromo = function() {
    if($scope.brand.name === 'akimbo' ||
       $scope.brand.name === 'officecard' ||
       $scope.brand.name === 'sunrise'
    ){
      return true;
    }
    return false;
  };
  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.validation.verifiedEmail = true;
    $rootScope.step1FormData = $scope.formData;

    // logic if reigster/enrollment
    if($scope.joinType != 'register'){
      $state.go('root.join.esign-disclosure', {joinType: $scope.joinType});
    } else {
      $state.go('root.join.step3', {joinType: $scope.joinType});
    }
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };

  };

}]);
